import { UntypedFormControl } from '@angular/forms';

export class FormControl extends UntypedFormControl {
	name: string;

	editing = false;
	submitted = false;

	// tslint:disable:no-empty */
	onReset: Function = () => {};
	onSubmitSuccess: Function = () => {};
}
